var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLegend0102(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.075 17v-1.372h-2.576a17.4 17.4 0 0 0-1.68.098c2.184-2.086 3.766-4.144 3.766-6.132 0-1.862-1.218-3.094-3.108-3.094-1.344 0-2.254.588-3.136 1.54l.91.896c.546-.63 1.218-1.148 2.03-1.148 1.148 0 1.75.77 1.75 1.89 0 1.694-1.568 3.696-4.606 6.384V17h6.65zm3.947.182c1.89 0 3.444-1.092 3.444-2.954 0-1.386-.938-2.282-2.128-2.576v-.07c1.092-.406 1.778-1.232 1.778-2.422 0-1.708-1.302-2.66-3.15-2.66-1.19 0-2.142.518-2.954 1.246l.84 1.008c.588-.574 1.26-.966 2.058-.98.98.014 1.582.588 1.582 1.498 0 1.036-.672 1.806-2.702 1.806v1.19c2.324 0 3.052.742 3.052 1.89 0 1.064-.798 1.708-1.96 1.708-1.064 0-1.834-.518-2.436-1.134l-.784 1.036c.686.77 1.736 1.414 3.36 1.414zm7.11 0c1.988 0 3.836-1.624 3.836-5.684 0-3.402-1.596-4.998-3.57-4.998-1.666 0-3.066 1.344-3.066 3.388 0 2.156 1.162 3.234 2.884 3.234.784 0 1.666-.462 2.268-1.204-.098 2.94-1.176 3.948-2.422 3.948a2.297 2.297 0 0 1-1.694-.77l-.868.994c.602.616 1.442 1.092 2.632 1.092zm.364-5.222c-1.078 0-1.666-.756-1.666-2.072 0-1.344.7-2.142 1.582-2.142 1.12 0 1.89.924 2.044 2.954-.616.896-1.33 1.26-1.96 1.26z",
    fill: "#6E1F1F",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLegend0102);
export default __webpack_public_path__ + "static/media/icon-legend-01-02.90505c7b747c4165df320bc6a4bcd00d.svg";
export { ForwardRef as ReactComponent };